// extracted by mini-css-extract-plugin
module.exports = {"tab":"tab_item__tab__D0YbU"};